import { CommunityProps } from 'src/client/types'
import { CommunityMemberPermissionsGroup, PermissionActions } from 'src/services/community'

export type CommunityListMenuProps = {
  className?: string
}

export type CommunityGroupProps = {
  id: number
  name: string
  slug: string
  order: number
  communities: {
    data: CommunityProps[]
  }
}

export type CommunityMemberPermissions = {
  group: CommunityMemberPermissionsGroup
  actions?: PermissionActions[]
}

export enum CommunityListMenuEventNames {
  CREATE_COMMUNITY = 'app-membership-consume:create-community',
  DELETE_COMMUNITY = 'app-membership-consume:delete-community',
  SET_UP_COMMUNITY = 'app-membership-consume:set-up-community',
  IMPORT_COMMUNITY = 'app-membership-consume:import-community',
  UPDATE_COMMUNITY_LIST = 'app-membership-consume:update-community-list',
  CREATE_COMMUNITY_GROUP = 'app-membership-consume:create-community-group',
  EDIT_COMMUNITY_GROUP = 'app-membership-consume:edit-community-group',
  DELETE_COMMUNITY_GROUP = 'app-membership-consume:delete-community-group',
  CLOSE_MODAL = 'app-membership-consume:close-modal'
}
